import { useQuery } from '@tanstack/react-query';

import { getEmployeeSearch } from '~/services/BusinessTraveller/BusinessTravellerService';

const EMPLOYEE_SEARCH_PAGE_SIZE = 20;
const EMPLOYEE_SEARCH_MIN_LENGTH = 2;

export const employeeSearchQueryKeys = {
  all: ['business-employees', 'search'] as const,
  search: (businessId: string, searchQuery: string) =>
    [...employeeSearchQueryKeys.all, businessId, searchQuery] as const,
};

/** Employees of a business matching a name or email search. */
export function useSearchEmployees(businessId: string, searchQuery: string) {
  const trimmedQuery = searchQuery.trim();
  return useQuery({
    queryKey: employeeSearchQueryKeys.search(businessId, trimmedQuery),
    queryFn: () => getEmployeeSearch(businessId, trimmedQuery, { pageSize: EMPLOYEE_SEARCH_PAGE_SIZE, page: 0 }),
    enabled: !!businessId && trimmedQuery.length >= EMPLOYEE_SEARCH_MIN_LENGTH,
  });
}
